import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import {
    Grid,
    Button,
    TextField,
    Link,
    Typography
} from '@material-ui/core';
import axios from 'axios';

import { API_LOCAL } from '../../constants';
import { Auth } from 'aws-amplify';

import { getPath } from '../../utils/common';
import CircularProgressButton from '../SignUp/components/CircularProgressButton';
import RegisterSnackBar from '../SignIn/components/RegisterSnackBar';
import { HORIZONTAL_LOGO as theLogo } from '../../constants';


const schema = {
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: true,
        length: {
            maximum: 64
        }
    },
    password: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            minimum: 8,
            message: "must be at least 8 characters",
            maximum: 128
        }
    },
    code: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            minimum: 4,
            message: "must be at least 4 characters",
            maximum: 10
        }
    }
};

makeStyles(theme => {
    console.log(theme)
});


const useStyles = makeStyles(theme => ({
    root: {
    },
    grid: {
        height: '100%'
    },
    contentContainer: {},
    content: {

        flexDirection: 'column'
    },
    panelSpacer: {
        width: 1,
        height: '15vh',
        minHeight: 208,
    },
    contentHeader: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        paddingBototm: '8px',
        paddingLeft: '8px',
        paddingRight: '8px'
    },
    logoImage: {
        marginLeft: '16px'
    },
    contentBody: {
        flexGrow: 1,
        // display: 'flex', 
        width: '45vw',
        minWidth: 320,
        maxWidth: 470,

    },
    form: {
        borderRadius: '8px',
        position: 'relative',
        top: '40%',
        textAlign: 'center',
        alignItems: 'center',
        paddingTop: 32,
        paddingLeft: '10%',
        paddingRight: '10%',
        paddingBottom: 48,
    },
    title: {
        marginTop: '8px'
    },
    suggestion: {
        marginTop: '8px'
    },
    textField: {
        marginTop: '8px',
    },

}));


const ResetPassword = (props) => {
    const { history, updateUser, apiManager, user } = props;
    const path = getPath();

    const data = props;

    const [error, handleError] = React.useState('');

    const [status, setStatus] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [isError, handleIsError] = React.useState(false);
    const [isValid, setIsValid] = React.useState(false);
    const [init, setInit] = React.useState(false);
    const [token, setToken] = React.useState(false);
    const [waitingForCode, setIsWaitingForCode] = React.useState(false);

    const [snackOpen, setSnackOpen] = React.useState(false);
    const [snackSuccess, setSnackSuccess] = React.useState(true);
    const [snackMessage, setSnackMessage] = React.useState('Success');


    const classes = useStyles();

    const [formState, setFormState] = useState({
        isValid: false,
        values: {
            email: '',
        },
        touched: {},
        errors: {},

    });


    const sendEmail = async (email) => {
        try {
            setIsWaitingForCode(true);
            const results = await apiManager.forgotPassword(email);
            setIsWaitingForCode(true);
        } catch (err) {
            alert(err.message);
            console.log(err);
        }
    }

    if (!init && !isValid) {
        setInit(true);
        if (path !== 'forgotpassword' && !waitingForCode) {
            sendEmail(user.email);
        }
    }

    useEffect(() => {
        const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [formState.values]);



    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            }
        }));
    };


    const [confirmed, setConfirmed] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);

    const resetWithCode = async (event) => {
        event.preventDefault();
    
        setIsConfirming(true);
    
        const userName = path === 'forgotpassword' ? formState.values.email : user.email

        try {
          const reset = await Auth.forgotPasswordSubmit(userName, formState.values.code, formState.values.password );
          setConfirmed(true);
  
          setSnackMessage('Password successfully changed.');
          setSnackSuccess(true);
          setSnackOpen(true);
            
          setTimeout( () => {
            if (path === 'forgotpassword') {
                history.push('/signin');
            } else {
                history.push('/account');
            }
          }, 3000);

        } catch (error) {
         // onError(error);
          setIsConfirming(false);
          setSnackMessage(`Sorry, there was an error: ${error.message}`);
          setSnackSuccess(false);
          setSnackOpen(true);
        }
      }

    const validateCodeForm = () => {
      
        if (!formState.values.code || !formState.values.password || !formState.values.confirm) {
            return false;
        }

        if (formState.values.code.length < 4 || (formState.values.password.length < 8) || formState.values.password !== formState.values.confirm) {
            return false;
        }
        return true;
    }

    //   const handleSignIn = async event => {
    //     event.preventDefault();

    //     const { confirm, password } = formState.values;
    //     const url = (API_LOCAL) + '/users/auth/reset/password';
    //     try {
    //       const result = await axios.post(url, { confirm, password, token })

    //       if(result && result.data && result.data.email){ 
    //         updateUser(result.data);
    //         localStorage.setItem('token', result.data.token);
    //         history.push('/briefs');
    //       }
    //       else {
    //         setFormState(formState => ({
    //           ...formState,
    //           error: 'Invalid login info'
    //         }));
    //         //updateUser({ name: 'test-user' });
    //         //history.push('/dashboard');
    //       }
    //     }
    //     catch(ex){
    //       console.log(ex);
    //       handleError(ex.toString())

    //     }

    //   };

    const renderError = () => {
        return (
            <div>
                ERROR!
            </div>
        )
    }

    const renderReset = () => {
        return (<div>
            <Typography
                className={classes.title}
                variant="body1"
            >
                An email has been sent to you with a Reset Code.<br />
                Enter the reset code and your new password below: <br /><br />
                {formState.error}
            </Typography>
            <TextField
                className={classes.textField}
                  error={hasError('code')}
                fullWidth
                  helperText={
                    hasError('code') ? formState.errors.code[0] : null
                  }
                autoComplete='off'
                label="Reset Code"
                name="code"
                onChange={handleChange}
                type="text"
                value={formState.values.code || ''}
                variant="outlined"
            />

            <TextField
                className={classes.textField}
                error={hasError('password')}
                fullWidth
                  helperText={
                    hasError('password') ? formState.errors.password[0] : null
                  }
                label="Password"
                name="password"
                onChange={handleChange}
                type="password"
                value={formState.values.password || ''}
                variant="outlined"
            />

            <TextField
                className={classes.textField}
                  error={hasError('confirm')}
                fullWidth
                  helperText={
                    hasError('confirm') ? formState.errors.confirm[0] : null
                  }
                label="Confirm password"
                name="confirm"
                onChange={handleChange}
                type="password"
                value={formState.values.confirm || ''}
                variant="outlined"
            />
            <br />  <br />
            <div style={{ 'text-align': 'center' }}>
                <CircularProgressButton
                    label="Reset Password"
                    onClick={resetWithCode}
                    disabled={!validateCodeForm()}
                />

            </div> </div>
        )
    }

    const renderForgot = () => {
        return (<div>
            <Typography
                className={classes.title}
                variant="body1"
            >
                Forgot your password?<br /><br />
    Enter your email and we'll send you a code so you can reset your password.
      {formState.error}
            </Typography><TextField
                className={classes.textField}
                error={hasError('email')}
                fullWidth
                helperText={
                    hasError('email') ? formState.errors.email[0] : null
                }
                label="Email"
                name="email"
                onChange={handleChange}
                type="email"
                value={formState.values.email || ''}
                variant="outlined"
            />

            <br />  <br />
            <div style={{ 'text-align': 'center' }}>
                <CircularProgressButton
                    isLoading={isLoading}
                    disabled={formState.values.email.length < 4}
                    label="Reset Password"
                    onClick={() => sendEmail(formState.values.email)}
                />

            </div> </div>
        )
    }

    const closeSnack = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setSnackOpen(false);
      };

    const handleLogin = () => {
        history.push('/signin');
    }

    const hasError = field =>
        formState.touched[field] && formState.errors[field] ? true : false;

    return (
        <div className={classes.root}>
            <Grid
                className={classes.content}
                item
                lg={12}
                xs={12}
                alignItems="center"
                container
            >
                <div className={classes.content}>
                    <div className={classes.panelSpacer} />
                    <div className={classes.contentBody}>
                        <RegisterSnackBar
                            isOpen={snackOpen}
                            isSuccessfull={snackSuccess}
                            message={snackMessage}
                            closeModal={closeSnack}
                        />
                        <form
                            className={classes.form}
                        //    onSubmit={handleSignIn}
                        >
                            <Typography
                                className={classes.title}
                                variant="body1"
                            >
                                <img src={theLogo} alt="Soil Health Academy.com" width="200px" align='middle' />


                            </Typography>
                            <Typography
                                className={classes.title}
                                variant="body1"
                            >
                                {formState.error}
                            </Typography>
                            <br />
                            <span style={{ color: 'blue' }}>{status}</span>

                            {isError ? renderError() :
                                <>
                                    {path === 'forgotpassword' && !waitingForCode
                                        ? <span>
                                              {renderForgot()}
                                               <div style={{ 'textAlign': 'center' }}>
                                                <br /> Remembered your password?
                                                    <Link href="#" onClick={handleLogin}>
                                                    Sign In
                                                    </Link>
                                            </div>
                                        </span>
                                        : <span>
                                                {renderReset()}
                                                <div style={{ 'textAlign': 'center', fontFamily: 'sans-serif' }}>
                                                <br /> 
                                                    <Link href="/account">
                                                        Cancel
                                                    </Link>
                                            </div>
                                          </span>
                                    }
                                </>
                            }


                        </form>
                    </div>
                </div>
            </Grid>

        </div>
    );

};

ResetPassword.propTypes = {
    history: PropTypes.object,
    updateUser: PropTypes.func
};

export default withRouter(ResetPassword);
